import { firestore, collection, query, where, getDocs } from "../firebase/firebaseConfig";

/**
 * Generates a unique referral code.
 * @param {string} userId - The UID of the user.
 * @returns {Promise<string>} - A unique referral code.
 */
export const generateReferralCode = async (userId) => {
  const characters = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // Avoids similar characters like O, 0, I, 1
  let referralCode = "";

  // Generate a random 6-character alphanumeric code
  for (let i = 0; i < 6; i++) {
    referralCode += characters.charAt(Math.floor(Math.random() * characters.length));
  }

  // Ensure the code is unique in Firestore
  const isCodeUnique = async (code) => {
    const usersRef = collection(firestore, "users");
    const querySnapshot = await getDocs(query(usersRef, where("referralCode", "==", code)));
    return querySnapshot.empty; // If no existing code, it's unique
  };

  while (!(await isCodeUnique(referralCode))) {
    console.warn(`Referral code ${referralCode} already exists. Generating a new one...`);
    referralCode = "";
    for (let i = 0; i < 6; i++) {
      referralCode += characters.charAt(Math.floor(Math.random() * characters.length));
    }
  }

  console.log(`Generated referral code: ${referralCode} for user ${userId}`);
  return referralCode;
};
